//菜单：服务管理页面
import React from 'react'
import Manager from '../../public/components/Manager'
import SysServiceDiv from '../SysManage/SysServiceDiv'
Ext.require('Ext.Toast')


const config = {
  tabs: {
    系统服务: {
      buttons: [
      ],
      columns: [
        // { _text: '运行状态', minWidth: 100, },
        // {
        //   _button: '', icon: o => o.运行状态 == '活动' ? 'check-circle' : 'minus-circle', ui: o => o.运行状态 == '活动' ? '' : 'decline', minWidth: 50, title: '运行状态'
        // },
        {
          _text: '服务', field: 'Name', minWidth: 200, flex: 1,
          tools: [
            { _tool: '', text: o => o.运行状态, icon: o => o.运行状态 == '活动' ? 'check-circle' : 'minus-circle', ui: o => o.运行状态 == '活动' ? 'action' : 'decline' },
            // { _tool: '', text: o => o.运行状态, icon: o => o.运行状态 == '活动' ? 'check-circle' : 'minus-circle', ui: o => o.运行状态 == '活动' ? 'action' : 'decline', zone: 'start' },
            // { _tool: '', text: o => o.运行状态, icon: o => o.运行状态 == '活动' ? 'check-circle' : 'minus-circle', ui: o => o.运行状态 == '活动' ? 'action' : 'decline', zone: 'head' },
            // { _tool: '', text: o => o.运行状态, icon: o => o.运行状态 == '活动' ? 'check-circle' : 'minus-circle', ui: o => o.运行状态 == '活动' ? 'action' : 'decline', zone: 'tail' },
            // { _tool: '', text: o => o.运行状态, icon: o => o.运行状态 == '活动' ? 'check-circle' : 'minus-circle', ui: o => o.运行状态 == '活动' ? 'action' : 'decline', zone: 'end', }
          ]
        },
        { _text: '运行间隔', field: '_MinTimeSpan', minWidth: 150, flex: 1 },
        { _text: '运行时间', field: 'RunTime', minWidth: 150, flex: 1 },
        { _text: '上次运行', field: '_LastRun', minWidth: 150, flex: 1 }
      ],
      onDoubleTap: ({ showDetail, refreshPage }, data) => {
        Tyan.pubForm.showDialog('服务配置', props => <SysServiceDiv {...props} id={data.id} onSave={refreshPage} />)
      }
    },
    自定义服务: {
      buttons: [
        {
          icon: 'plus', text: '添加', handler: ({ showDetail, refreshPage }) =>
            Tyan.pubForm.showDialog('服务配置', props => <SysServiceDiv {...props} id={-1} onSave={refreshPage} />)
        },
      ],
      columns: [
        {
          _text: '服务', field: 'Name', minWidth: 300, flex: 1,
          tools: [{ _tool: '', text: o => o.运行状态, icon: o => o.运行状态 == '活动' ? 'check-circle' : 'minus-circle', ui: o => o.运行状态 == '活动' ? '' : 'decline' }]
        },
        { _text: '运行间隔', field: '_MinTimeSpan', minWidth: 150, flex: 1 },
        { _text: '运行时间', field: 'RunTime', minWidth: 150, flex: 1 },
        { _text: '上次运行', field: '_LastRun', minWidth: 150, flex: 1 },
      ],
      onDoubleTap: ({ showDetail, refreshPage }, data) => {
        Tyan.pubForm.showDialog('服务配置', props => <SysServiceDiv {...props} id={data.id} onSave={refreshPage} />)
      }
    },
  }
}

export default props => <Manager {...props} config={config} />